import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Toaster } from "./components/ui/sonner";
import SEOSchema from "./components/SEOSchema";
import Header from "./components/Header";
import Hero from "./components/Hero";
import OurWork from "./components/OurWork";
import PromoServices from "./components/PromoServices";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>UVD Media | Cinematic Book Trailers for Thriller Authors</title>
        <meta name="description" content="We turn thriller novels into cinematic trailers that feel like real films. Professional book trailer videos for thriller authors. Starting at $400." />
        <meta name="keywords" content="thriller book trailer, cinematic book trailer, book trailer video, thriller author marketing, book promotion video, Amazon book trailer, book marketing video, author video marketing, suspense book trailer, crime thriller trailer" />
        <meta property="og:title" content="UVD Media | Cinematic Book Trailers for Thriller Authors" />
        <meta property="og:description" content="We turn thriller novels into cinematic trailers that feel like real films. Professional book trailers starting at $400." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://uvdmedia.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="UVD Media | Cinematic Book Trailers for Thriller Authors" />
        <meta name="twitter:description" content="We turn thriller novels into cinematic trailers that feel like real films. Starting at $400." />
        <link rel="canonical" href="https://uvdmedia.com" />
      </Helmet>
      <SEOSchema />
      <Header />
      <Hero />
      <OurWork />
      <PromoServices />
      <About />
      <FAQ />
      <Contact />
      <Footer />
      <Chatbot />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
